/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SiteUnitConfigBackfillResultDto } from '../models/SiteUnitConfigBackfillResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SiteUnitConfigBackfillService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns SiteUnitConfigBackfillResultDto OK
     * @throws ApiError
     */
    public postApiHousingSiteUnitConfigBackfillPreviewBackfill(): CancelablePromise<SiteUnitConfigBackfillResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/SiteUnitConfigBackfill/PreviewBackfill',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns SiteUnitConfigBackfillResultDto OK
     * @throws ApiError
     */
    public postApiHousingSiteUnitConfigBackfillExecuteBackfill(): CancelablePromise<SiteUnitConfigBackfillResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/SiteUnitConfigBackfill/ExecuteBackfill',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
